<template>
  <div class="sn-f-b-s register">
    <sn-navigator id="GRZX" v-if="$route.query.mode === '3'"></sn-navigator>
    <div class="sn-f-1">
      <sn-breadcrumb :breadcrumb="[{
        title: title
      }]"></sn-breadcrumb>
      <div class="sn-f-col-c-c operate">
        <div class="blank">
          <div class="sn-f-b-e title" v-if="$route.query.mode !== '3'">
            <div class="sn-f-c-c title-caption">{{ title }}</div>
            <div class="sn-f-1 title-line"></div>
          </div>
          <div class="main">
            <div class="sn-f-s-c main-line">
              <div class="sn-f-e-c main-title">手机号：</div>
              <div class="main-input">
                <input placeholder="请输入您的手机号" maxlength="11" v-model="user.phone" @keydown.enter="handle();"/>
              </div>
              <div class="sn-fc-red1">*</div>
            </div>
            <div class="sn-f-s-c main-line">
              <div class="sn-f-e-c main-title">动态码：</div>
              <div class="main-input">
                <input placeholder="请输入您的动态码" maxlength="6" v-model="user.code" @keydown.enter="handle();"/>
              </div>
              <div class="sn-f-c-c sn-pointer code" :class="{'code-default': serial < 60}" @click="sendCode();">{{ serial < 60 ? '重新获取(' + serial + ')s' : '获取动态码' }}</div>
              <div class="sn-fc-red1">*</div>
            </div>
            <template v-if="$route.query.mode !== '0'">
              <div class="sn-f-s-c main-line">
                <div class="sn-f-e-c main-title">新密码：</div>
                <div class="main-input">
                  <input placeholder="请输入您的密码" maxlength="16" :type="hide.n ? 'password' : 'text'" v-model="user.password.n" @keydown.enter="handle();"/>
                  <div class="iconfont" :class="hide.n ? 'icon-yincang' : 'icon-kekan'" @click="hide.n = !hide.n;"></div>
                </div>
                <div class="sn-fc-red1">*</div>
              </div>
              <div class="sn-f-s-c main-line">
                <div class="sn-f-e-c main-title">确认密码：</div>
                <div class="main-input">
                  <input placeholder="请再次输入您的密码" maxlength="16" :type="hide.r ? 'password' : 'text'" v-model="user.password.r" @keydown.enter="handle();"/>
                  <div class="iconfont" :class="hide.r ? 'icon-yincang' : 'icon-kekan'" @click="hide.r = !hide.r;"></div>
                </div>
                <div class="sn-fc-red1">*</div>
              </div>
            </template>
          </div>
          <div class="tip" v-if="$route.query.mode !== '0'">密码必须由8-16位的数字，字母或特殊字符中的任意两种组成。</div>
          <div class="sn-f-c-c sn-pointer interaction" @click="handle();">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import LoginMixin from '@/pages/login/login-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  mixins: [LoginMixin],
  data() {
    return {
      title: '',
      user: {
        phone: '',
        password: {
          n: '',
          r: ''
        },
        code: ''
      },
      hide: {
        n: true,
        r: true
      }
    };
  },
  created: function() {
    const TitleCompare = {
      '0': '绑定手机号',
      '1': '注册',
      '2': '忘记密码',
      '3': '修改密码'
    };
    this.title = TitleCompare[this.$route.query.mode];
    document.title = this.title;
    this.$route.meta.title = this.title;
    if (this.serial < 60) this.formatSerial();
  },
  methods: {
    async sendCode() {
      if (this.serial < 60) return false;
      if (!this.$sn.validate.phone(this.user.phone)) {
        this.$sn.assembly.toast({
          caption: Messages.C013
        });
        return false;
      }
      if (['1', '2', '3'].includes(this.$route.query.mode)) {
        this.$sn.assembly.loading(true);
        const verify = await this.login_mixin_verifyRegister(this.user.phone);
        this.$sn.assembly.loading(false);
        if (verify.code === 0) {
          if (verify.data) {
            if (this.$route.query.mode === '1') {
              this.$sn.assembly.toast({
                caption: Messages.LOGIN006
              });
              return false;
            }
          }
          else {
            if (['2', '3'].includes(this.$route.query.mode)) {
              this.$sn.assembly.toast({
                caption: Messages.LOGIN007
              });
              return false;
            }
          }
        }
        else {
          this.$sn.assembly.toast({
            caption: verify.msg
          });
          return false;
        }
      }
      const CodeTypeCompare = {
        '0': '4',
        '1': '1',
        '2': '2'
      };
      this.login_mixin_sendCode(this.user.phone, CodeTypeCompare[this.$route.query.mode]);
    },
    handle() {
      if (!this.$sn.validate.phone(this.user.phone)) {
        this.$sn.assembly.toast({
          caption: Messages.C013
        });
        return false;
      }
      else if (!this.$sn.validate.code(this.user.code)) {
        this.$sn.assembly.toast({
          caption: this.$sn.format.caption(Messages.C031, ['您的动态码'])
        });
        return false;
      }
      if (this.$route.query.mode === '0') {
        if (this.$sn.validate.empty(this.$route.query.snCode)) {
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C018, ['snCode'])
          });
          return false;
        }
      }
      else {
        if (!this.$sn.validate.password(this.user.password.n) || !this.$sn.validate.password(this.user.password.r)) {
          this.$sn.assembly.toast({
            caption: Messages.C033
          });
          return false;
        }
        if (this.user.password.n !== this.user.password.r) {
          this.$sn.assembly.toast({
            caption: Messages.C034
          });
          return false;
        }
      }
      let params = {};
      if (this.$route.query.mode === '0') {
        params = {
          url: Swagger.bindWx,
          method: 'POST',
          data: JSON.stringify({
            mobile: this.user.phone,
            smsCode: this.user.code,
            snCode: this.$route.query.snCode
          })
        };
      }
      else if (this.$route.query.mode === '1') {
        params = {
          url: Swagger.register,
          method: 'POST',
          data: JSON.stringify({
            hosId: this.$sn.utils.getHospitalId(),
            mobile: this.user.phone,
            password: this.user.password.n,
            platformType: this.$sn.utils.getPlatformType(),
            projectType: '',
            verifyCode: this.user.code
          })
        };
      }
      else if (['2', '3'].includes(this.$route.query.mode)) {
        params = {
          url: Swagger.changePassword,
          method: 'POST',
          data: JSON.stringify({
            hosId: this.$sn.utils.getHospitalId(),
            mobile: this.user.phone,
            password: this.user.password.n,
            platformType: this.$sn.utils.getPlatformType(),
            projectType: '',
            verifyCode: this.user.code
          })
        };
      }
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (this.$route.query.mode === '0') {
              this.login_mixin_suffixLogin(result.data);
            }
            else {
              const CaptionCompare = {
                '1': '注册',
                '2': '修改密码',
                '3': '修改密码'
              };
              this.$sn.assembly.toast({
                caption: this.$sn.format.caption(Messages.C016, CaptionCompare[this.$route.query.mode]),
                success: () => {
                  this.login_mixin_navigateUrl('/login', '', {}, 'replace');
                }
              });
            }
          }
          else {
            this.$sn.assembly.toast({
              caption: result.msg
            });
          }
        }
        else {
          this.$sn.assembly.toast({
            caption: Messages.C001
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.register {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .operate {
    padding-top: 40px;

    .blank {
      overflow: hidden;
      width: 60%;

      .title {
        width: 100%;
        height: 50px;

        &-caption {
          @include fs(16);

          width: 20%;
          height: 50px;
          border-top: 10px solid $main;
          border-right: 1px solid $border1;
          border-left: 1px solid $border1;
        }

        &-line {
          height: 1px;
          background-color: $border1;
        }
      }

      .main {
        margin-top: 20px;

        .main-line {
          @include fs(16);

          width: 100%;
          height: 50px;

          .main-title {
            width: 20%;
          }

          .main-input {
            width: 40%;
            margin-right: 10px;
            position: relative;

            input {
              @include fs(16);

              outline: none;
              width: 100%;
              height: 40px;
              border: 1px solid $border1;
              border-radius: 5px;
              padding: 0 10px;

              &::-webkit-input-placeholder {
                opacity: 1 !important;
                color: $text3;
              }

              &:focus {
                border: 1px solid $main;
              }
            }

            .iconfont {
              font-size: 14px;
              color: $text3;
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);
            }

            .icon-yincang {
              font-size: 10px;
            }
          }

          .code {
            @include fs(16);

            height: 40px;
            background-color: $white;
            color: $main;
            border: 1px solid $main;
            border-radius: 5px;
            padding: 0 10px;
            margin-right: 10px;
            margin-left: 8px;

            &-default {
              color: $text3;
              border: 1px solid $border1;
            }
          }
        }
      }

      .tip {
        @include fs(14);

        color: $red1;
        margin-top: 10px;
        margin-left: 20%;
      }

      .interaction {
        @include fs(16);

        width: 40%;
        height: 40px;
        background-color: $main;
        color: $white;
        border-radius: 5px;
        margin-top: 20px;
        margin-left: 20%;
      }
    }
  }
}
</style>
